export default __webpack_public_path__ + "static/TileMenu_Horizontal-40791a8ad3939ead79f60e15799a5291.png";